
<template>
  <div>
    <div>
      <p>
        <b-button
          type="is-primary"
          icon-left="plus"
          :disabled="disabledbool"
          @click="addMaterial"
        >
          {{ $translate('add_material') | capitalize }}
        </b-button>
      </p>
    </div>
    <div style="margin-top: 20px">
      <b-field
        v-for="material in materials"
        :key="material.id"
        grouped
      >
        <b-field
          :type="{
            'is-danger': errors.has('materialname' + materialType + material.id),
          }"
          :message="errors.first('materialname' + materialType + material.id)"
        >
          <b-select
            v-model="material.name"
            v-validate="'required'"
            :name="'materialname' + materialType + material.id"
            :disabled="disabledbool"
            :placeholder="$translate('placeholder_material')"
          >
            <option
              v-for="option in availablematerial"
              :key="option"
              :value="option"
            >
              {{ $translate(option) }}
            </option>
          </b-select>
        </b-field>
        <b-field
          :type="{
            'is-danger': errors.has('materialqty' + materialType + material.id),
          }"
          :message="errors.first('materialqty' + materialType + material.id)"
        >
          <b-numberinput
            v-model="material.qty"
            min="1"
            :name="'materialqty' + materialType + material.id"
            :disabled="disabledbool"
          />
        </b-field>
        <b-button
          :disabled="disabledbool"
          type="is-primary"
          icon-left="minus"
          @click="removeMaterial(material.id)"
        >
          {{ $translate('remove_material') | capitalize }}
        </b-button>
      </b-field>
    </div>
  </div>
</template>

<script>
export default {
  name: "ManageMaterials",
  props: {
    availablematerial: {
      type: Array,
      default: () => {
        return []
      }
    },
    materials: {
      type: Array,
      default: () => {
        return []
      }
    },
    disabledbool: {
      type: Boolean,
      default: false
    },
    card2: {
      type: String,
      default: ""
    },
    materialType: {
      type: String,
      default: ""
    }
  },
  inject: ["$validator"],
  watch: {
    card2: function() {
      if (this.card2 == "card2" && this.materials.length == 0) {
        this.addMaterial();
      }
    },
  },
  methods: {
    addMaterial() {
      this.materials.push({ id: this.materials.length, name: "", qty: 1 });
    },
    removeMaterial(index) {
      if (this.card2 == "card2" && this.materials.length == 1) {
        this.$buefy.notification.open({
          duration: 3000,
          message: this.$translate("warning_card2_at_least_prod"),
          type: "is-warning",
        });
      } else {
        this.materials.splice(index, 1);
        for (let i = 0; i < this.materials.length; i++) {
          this.materials[i].id = i;
        }
      }
    },
  },
};
</script>
